import {
  Box,
  Flex,
  Icon,
  SimpleGrid,
  Spinner,
  Stat,
  StatLabel,
  StatNumber
} from '@chakra-ui/react'
import { FC } from 'react'
import {
  MdCheckCircle,
  MdEmail,
  MdHourglassEmpty,
  MdStackedBarChart
} from 'react-icons/md'

interface IListagemKpi {
  total: number
  emailEnviado: number
  submetido: number
  aprovados: number
}

interface Props {
  kpi: IListagemKpi
  kpiLoading: boolean
}

const KpiCards: FC<Props> = ({ kpi, kpiLoading }) => (
  <SimpleGrid columns={4} spacing={3} px={4} pt={4} pb={2}>
    {(
      [
        {
          label: 'Total (pares)',
          value: kpi.total,
          color: '#2d3748',
          bg: 'gray.50',
          border: 'gray.200',
          iconBg: 'gray.100',
          iconColor: 'gray.500',
          icon: MdStackedBarChart
        },
        {
          label: 'E-mail Enviado (disparos)',
          value: kpi.emailEnviado,
          color: '#2b6cb0',
          bg: 'blue.50',
          border: 'blue.200',
          iconBg: 'blue.100',
          iconColor: 'blue.500',
          icon: MdEmail
        },
        {
          label: 'Submetido (disparos)',
          value: kpi.submetido,
          color: '#6b46c1',
          bg: 'purple.50',
          border: 'purple.200',
          iconBg: 'purple.100',
          iconColor: 'purple.500',
          icon: MdHourglassEmpty
        },
        {
          label: 'Aprovados (pares)',
          value: kpi.aprovados,
          color: '#276749',
          bg: 'green.50',
          border: 'green.200',
          iconBg: 'green.100',
          iconColor: 'green.600',
          icon: MdCheckCircle
        }
      ] as const
    ).map(({ label, value, color, bg, border, iconBg, iconColor, icon }) => (
      <Box
        key={label}
        borderWidth="1.5px"
        borderColor={border}
        borderRadius="xl"
        p={4}
        bg={bg}
        boxShadow="sm"
      >
        <Flex justify="space-between" align="flex-start">
          <Stat>
            <StatLabel
              fontSize="10px"
              textTransform="uppercase"
              color="gray.500"
              letterSpacing="0.8px"
              fontWeight="600"
            >
              {label}
            </StatLabel>
            <StatNumber fontSize="26px" color={color} mt={1}>
              {kpiLoading ? <Spinner size="sm" color={iconColor} /> : value}
            </StatNumber>
          </Stat>
          <Box bg={iconBg} borderRadius="lg" p={2} mt={1}>
            <Icon as={icon} boxSize={5} color={iconColor} />
          </Box>
        </Flex>
      </Box>
    ))}
  </SimpleGrid>
)

export default KpiCards
